import { Theme } from "@mui/material/styles/createTheme";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
    // Same one-screen frame as the Summary report. The rows need a definite height: Nivo's responsive charts size
    // themselves to their card, so content-sized rows would keep growing with them.
    gridContainer: {
        display: "grid",
        gap: theme.spacing(3),
        gridTemplateColumns: "240px repeat(4, minmax(0, 1fr))",
        gridTemplateRows: "repeat(2, minmax(0, 1fr))",
        height: "calc(100vh - 222px)",
        width: "100vw",
        boxSizing: "border-box",
        padding: theme.spacing(6),
    },
    // The gauge cards have a legibility floor, so on a screen too short for four of them the column scrolls
    // instead of squeezing the headline numbers until they cannot be read.
    gaugeColumn: {
        gridRow: "1 / -1",
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
        minHeight: 0,
        overflowY: "auto",
    },
    trendRow: {
        gridColumn: "2 / -1",
        display: "flex",
        minHeight: 0,
        minWidth: 0,
        "& > *": {
            flex: 1,
            minWidth: 0,
        },
    },
}));
